var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"add-text",on:{"click":_vm.clickAdd}},[_c('i',{staticClass:"iconfont ux_icon_plus"}),_c('i',[_vm._v(_vm._s(_vm.$t('HT.add')))])])}
var staticRenderFns = []

export { render, staticRenderFns }